import { analytics } from 'moet-core';
const commonProperties = ['onboardingKrn', 'onboardingType'];
export const ANALYTICS_EVENTS = {
    appLoaded: new analytics.Event({
        name: 'Generic onboarding loaded',
        description: 'Business partner loads the generic onboarding flow',
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.NAVIGATION,
        properties: [...commonProperties, 'currentGroupId'],
        userAttributes: ['onboardingType'],
    }),
    backButton: new analytics.Event({
        name: 'Back Button Clicked',
        description: 'Business partner goes back to previous page',
        action: analytics.EVENT_ACTION.BACK_BUTTON_CLICK,
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.NAVIGATION,
        properties: [...commonProperties, 'currentGroupId', 'destinationGroupId'],
        userAttributes: ['onboardingType'],
    }),
    // @ts-expect-error: FIXME
    continueButton: (absolutePathsOfFieldsToSendWithTheEvent) => new analytics.Event({
        name: 'Continue Button Clicked',
        description: 'Business partner continues to next page',
        action: analytics.EVENT_ACTION.CTA_CLICK,
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.USER_PREFERENCE,
        properties: [
            ...commonProperties,
            ...absolutePathsOfFieldsToSendWithTheEvent,
            'currentGroupId',
            'destinationGroupId',
        ],
        userAttributes: ['onboardingType'],
    }),
    pageView: new analytics.Event({
        name: 'Onboarding Step Viewed',
        description: 'Business partner views an onboarding step',
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.NAVIGATION,
        properties: [...commonProperties, 'currentGroupId'],
        userAttributes: ['onboardingType'],
    }),
    submitSensitiveGoods: new analytics.Event({
        name: 'Sensitive goods question answered',
        description: 'Merchant answers question whether they sell sensitive goods',
        action: analytics.EVENT_ACTION.CTA_CLICK,
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.USER_PREFERENCE,
        properties: ['sellsSensitiveGoods'],
        userAttributes: ['sellsSensitiveGoods'],
    }),
    applicationSubmitted: new analytics.Event({
        name: 'Application Submitted',
        description: 'Merchant accepts TOC & submits application',
        action: analytics.EVENT_ACTION.FORM_SUBMIT,
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.USER_PREFERENCE,
        properties: [...commonProperties],
    }),
    exitPointClicked: new analytics.Event({
        name: 'Exit Point Clicked',
        description: 'Business partner goes to exit point',
        action: analytics.EVENT_ACTION.CTA_CLICK,
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.NAVIGATION,
        properties: [...commonProperties, 'exitPoint'],
    }),
    entryPointClicked: new analytics.Event({
        name: 'Entry Point Clicked',
        description: 'Business partner goes back to entry point',
        action: analytics.EVENT_ACTION.CTA_CLICK,
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.NAVIGATION,
        properties: [...commonProperties, 'entryPoint'],
    }),
    statusChanged: new analytics.Event({
        name: 'Application Status Changed',
        description: 'Business partner application goes from one status to another',
        action: analytics.EVENT_ACTION.APPLICATION_STATUS_CHANGE,
        category: analytics.EVENT_CATEGORY.FLOW_STEP,
        // @ts-expect-error: FIXME
        type: analytics.EVENT_TYPE.OTHER,
        properties: [...commonProperties, 'oldStatus', 'newStatus'],
    }),
};
